import React from 'react'

function Recorder(props) {
    
  return (
    <div className='Recorder'>

    </div>
  )
}

export default Recorder